module.exports = {
  "data": [
    {
      "hotelId": "lp1897",
      "roomTypes": [
        {
          "roomTypeId": "rt-standard-room",
          "name": "Standard Room",
          "offerId": "offer-standard-room-1",
          "supplier": "Nuitee",
          "supplierId": 2,
          "rates": [
            {
              "rateId": "rate-standard-room-1",
              "name": "Standard Room",
              "maxOccupancy": 2,
              "adultCount": 2,
              "retailRate": {
                "total": [
                  {
                    "amount": 219,
                    "currency": "USD"
                  }
                ],
                "initialPrice": [
                  {
                    "amount": 239,
                    "currency": "USD"
                  }
                ]
              },
              "boardType": "RO",
              "boardName": "Room Only",
              "priceType": "commission",
              "paymentTypes": [
                "AT_WEB"
              ],
              "cancellationPolicies": {
                "cancelPolicyInfos": [
                  {
                    "cancelTime": "2026-06-29T23:59:00Z",
                    "amount": 0,
                    "currency": "USD",
                    "type": "amount",
                    "timezone": "GMT"
                  }
                ],
                "hotelRemarks": [],
                "refundableTag": "RFN"
              }
            }
          ]
        },
        {
          "roomTypeId": "rt-premium-room",
          "name": "Premium Room",
          "offerId": "offer-premium-room-1",
          "supplier": "Nuitee",
          "supplierId": 2,
          "rates": [
            {
              "rateId": "rate-premium-room-1",
              "name": "Premium Room",
              "maxOccupancy": 2,
              "adultCount": 2,
              "retailRate": {
                "total": [
                  {
                    "amount": 269,
                    "currency": "USD"
                  }
                ],
                "initialPrice": [
                  {
                    "amount": 289,
                    "currency": "USD"
                  }
                ]
              },
              "boardType": "BB",
              "boardName": "Bed & Breakfast",
              "priceType": "commission",
              "paymentTypes": [
                "AT_WEB"
              ],
              "cancellationPolicies": {
                "cancelPolicyInfos": [
                  {
                    "cancelTime": "2026-06-29T23:59:00Z",
                    "amount": 0,
                    "currency": "USD",
                    "type": "amount",
                    "timezone": "GMT"
                  }
                ],
                "hotelRemarks": [],
                "refundableTag": "RFN"
              }
            }
          ]
        },
        {
          "roomTypeId": "rt-standard-queen",
          "name": "Standard Queen Room",
          "offerId": "offer-standard-queen-1",
          "supplier": "Nuitee",
          "supplierId": 2,
          "rates": [
            {
              "rateId": "rate-standard-queen-1",
              "name": "Standard Queen Room",
              "maxOccupancy": 2,
              "adultCount": 2,
              "retailRate": {
                "total": [
                  {
                    "amount": 239,
                    "currency": "USD"
                  }
                ],
                "initialPrice": [
                  {
                    "amount": 259,
                    "currency": "USD"
                  }
                ]
              },
              "boardType": "RO",
              "boardName": "Room Only",
              "priceType": "commission",
              "paymentTypes": [
                "AT_WEB"
              ],
              "cancellationPolicies": {
                "cancelPolicyInfos": [
                  {
                    "cancelTime": "2026-06-29T23:59:00Z",
                    "amount": 0,
                    "currency": "USD",
                    "type": "amount",
                    "timezone": "GMT"
                  }
                ],
                "hotelRemarks": [],
                "refundableTag": "RFN"
              }
            }
          ]
        },
        {
          "roomTypeId": "rt-standard-king",
          "name": "Standard King Room",
          "offerId": "offer-standard-king-1",
          "supplier": "Nuitee",
          "supplierId": 2,
          "rates": [
            {
              "rateId": "rate-standard-king-1",
              "name": "Standard King Room",
              "maxOccupancy": 2,
              "adultCount": 2,
              "retailRate": {
                "total": [
                  {
                    "amount": 289,
                    "currency": "USD"
                  }
                ],
                "initialPrice": [
                  {
                    "amount": 309,
                    "currency": "USD"
                  }
                ]
              },
              "boardType": "BB",
              "boardName": "Bed & Breakfast",
              "priceType": "commission",
              "paymentTypes": [
                "AT_WEB"
              ],
              "cancellationPolicies": {
                "cancelPolicyInfos": [
                  {
                    "cancelTime": "2026-06-29T23:59:00Z",
                    "amount": 289,
                    "currency": "USD",
                    "type": "amount",
                    "timezone": "GMT"
                  }
                ],
                "hotelRemarks": [],
                "refundableTag": "NRFN"
              }
            }
          ]
        },
        {
          "roomTypeId": "rt-standard-double-two-beds",
          "name": "Standard Double Room with Two Double Beds",
          "offerId": "offer-standard-double-two-beds-1",
          "supplier": "Nuitee",
          "supplierId": 2,
          "rates": [
            {
              "rateId": "rate-standard-double-two-beds-1",
              "name": "Standard Double Room with Two Double Beds",
              "maxOccupancy": 4,
              "adultCount": 2,
              "retailRate": {
                "total": [
                  {
                    "amount": 309,
                    "currency": "USD"
                  }
                ],
                "initialPrice": [
                  {
                    "amount": 329,
                    "currency": "USD"
                  }
                ]
              },
              "boardType": "RO",
              "boardName": "Room Only",
              "priceType": "commission",
              "paymentTypes": [
                "AT_WEB"
              ],
              "cancellationPolicies": {
                "cancelPolicyInfos": [
                  {
                    "cancelTime": "2026-06-29T23:59:00Z",
                    "amount": 0,
                    "currency": "USD",
                    "type": "amount",
                    "timezone": "GMT"
                  }
                ],
                "hotelRemarks": [],
                "refundableTag": "RFN"
              }
            }
          ]
        },
        {
          "roomTypeId": "rt-premium-queen-manhattan-floor",
          "name": "Premium Queen Room - Manhattan Floor",
          "offerId": "offer-premium-queen-manhattan-floor-1",
          "supplier": "Nuitee",
          "supplierId": 2,
          "rates": [
            {
              "rateId": "rate-premium-queen-manhattan-floor-1",
              "name": "Premium Queen Room - Manhattan Floor",
              "maxOccupancy": 2,
              "adultCount": 2,
              "retailRate": {
                "total": [
                  {
                    "amount": 329,
                    "currency": "USD"
                  }
                ],
                "initialPrice": [
                  {
                    "amount": 349,
                    "currency": "USD"
                  }
                ]
              },
              "boardType": "BB",
              "boardName": "Bed & Breakfast",
              "priceType": "commission",
              "paymentTypes": [
                "AT_WEB"
              ],
              "cancellationPolicies": {
                "cancelPolicyInfos": [
                  {
                    "cancelTime": "2026-06-29T23:59:00Z",
                    "amount": 329,
                    "currency": "USD",
                    "type": "amount",
                    "timezone": "GMT"
                  }
                ],
                "hotelRemarks": [],
                "refundableTag": "NRFN"
              }
            }
          ]
        }
      ],
      "hotel": {
        "id": "lp1897",
        "name": "The Manhattan at Times Square",
        "city": "New York",
        "countryCode": "US",
        "main_photo": "https://static.cupid.travel/hotels-large-pictures/202906383.jpg",
        "starRating": 4,
        "reviewCount": 6536,
        "rating": 5.6
      }
    }
  ],
  "meta": {
    "currency": "USD",
    "checkin": "2026-07-01",
    "checkout": "2026-07-03"
  }
};
